import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Bug, CircleHelp, Compass, Mail, MessageCircleQuestion } from 'lucide-react';
import { useRestartTour } from '@/help/use-restart-tour';
import { openAssistant, openReportProblem } from '@/help/assistant-store';

/**
 * زرُّ «؟» في الترويسة (27 سبتمبر 2026): قائمةٌ صغيرة — اسأل المساعد · أعد الجولة · مركز المساعدة ·
 * أبلغ عن مشكلة · تواصل معنا. وعلى الجوال تُخفى الترويسةُ فتنتقل كلُّها إلى أسفل «المزيد» (`HelpLinks`).
 * «اسأل المساعد» أولُها (29 سبتمبر 2026) لأنه أقربُ جوابٍ لسؤالٍ بكلمات المستخدم.
 */
export function HelpMenu({ className = '' }: { className?: string }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const restart = useRestartTour();
  useEffect(() => {
    if (!open) return;
    const away = (e: PointerEvent) => { if (!root.current?.contains(e.target as Node)) setOpen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', away);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('pointerdown', away); document.removeEventListener('keydown', esc); };
  }, [open]);
  return (
    <div ref={root} className={`help-menu ${className}`.trim()}>
      <button type="button" className="pref-btn" data-tour="help" aria-expanded={open} aria-haspopup="true" aria-label="المساعدة" title="المساعدة" onClick={() => setOpen((v) => !v)}>
        <CircleHelp aria-hidden />
      </button>
      {open && (
        <div className="help-menu__pop">
          <button type="button" className="help-menu__item" data-testid="menu-ask" onClick={() => { setOpen(false); openAssistant(); }}><MessageCircleQuestion aria-hidden /><span>اسأل المساعد</span></button>
          <button type="button" className="help-menu__item" onClick={() => { setOpen(false); restart(); }}><Compass aria-hidden /><span>أعد الجولة</span></button>
          <Link to="/help" className="help-menu__item" onClick={() => setOpen(false)}><BookOpen aria-hidden /><span>مركز المساعدة</span></Link>
          <button type="button" className="help-menu__item" data-testid="menu-report" onClick={() => { setOpen(false); openReportProblem(); }}><Bug aria-hidden /><span>أبلغ عن مشكلة</span></button>
          <Link to="/contact" className="help-menu__item" onClick={() => setOpen(false)}><Mail aria-hidden /><span>تواصل معنا</span></Link>
        </div>
      )}
    </div>
  );
}

/** الأبوابُ نفسُها في أسفل «المزيد» على الجوال */
export function HelpLinks({ onPick }: { onPick: () => void }) {
  const restart = useRestartTour();
  return (
    <div className="help-links">
      <button type="button" className="help-menu__item" data-testid="more-ask" onClick={() => { onPick(); openAssistant(); }}><MessageCircleQuestion aria-hidden /><span>اسأل المساعد</span></button>
      <button type="button" className="help-menu__item" onClick={() => { onPick(); restart(); }}><Compass aria-hidden /><span>أعد الجولة</span></button>
      <Link to="/help" className="help-menu__item" onClick={onPick}><BookOpen aria-hidden /><span>مركز المساعدة</span></Link>
      <button type="button" className="help-menu__item" onClick={() => { onPick(); openReportProblem(); }}><Bug aria-hidden /><span>أبلغ عن مشكلة</span></button>
      <Link to="/contact" className="help-menu__item" onClick={onPick}><Mail aria-hidden /><span>تواصل معنا</span></Link>
    </div>
  );
}
